export const PAYMENT_TYPES = {
  PROVIDER: 1,
  REIMBURSEMENT: 2,
} as const

export const DOCUMENT_TYPES = {
  INVOICE: 1,
  APPEAL: 6,
} as const

export interface PaymentFile {
  document_type?: number
  file_name?: string
  student_id?: number
  invoice_number?: string
  invoice_date?: string
  amount?: number
  notes?: string
}

export interface PaymentPurse {
  purse_id?: number
  amount?: number
}

export interface Category {
  id: number
  amount: number
  name: string
}

interface DefaultPayload {
  program_id: number // min: 1, required
  type: (typeof PAYMENT_TYPES)[keyof typeof PAYMENT_TYPES] // 1 or 2
  global_expense_categories: Omit<Category, 'name'>[]
  invoice_quote: string
  comments: string
  files: {
    file_name: string
    document_type: typeof DOCUMENT_TYPES.INVOICE
  }[]
  purses: PaymentPurse[]
}

// For type 1 payments (with provider)
export interface ProviderPaymentPayload extends Omit<DefaultPayload, 'files'> {
  type: typeof PAYMENT_TYPES.PROVIDER
  provider_id: number // min: 1, required
  base_amount: number
  files: {
    file_name: string
    document_type: typeof DOCUMENT_TYPES.INVOICE
    student_id: number
    invoice_number: string
    invoice_date: string
    amount: number
    notes?: string
  }[]
}

// For type 2 payments (without provider)
export interface NonProviderPaymentPayload extends DefaultPayload {
  type: typeof PAYMENT_TYPES.REIMBURSEMENT
  store_name: string // required
  // provider_id is intentionally excluded
}

// Type union to enforce the conditional requirement
export type PaymentPayload = ProviderPaymentPayload | NonProviderPaymentPayload

export type AppealPaymentPayload = PaymentPayload & {
  payment_id: number
  status: number
  total_amount: number
}

export interface AppealMarketplacePaymentPayload {
  payment_id: number
  program_id: number
  status: number
  applicant_appeal_message: string
}
